module.exports = require('./lib/marvel-ui-tabs.js');



//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/tabs.js
// module id = 1118
// module chunks = 35783957827783